import { Component } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import withRouter from '../../../../hoc/withRouter';
import Datatable from '../../../../components/common/datatable/index';
import Can from '../../../../components/common/guards/can';

class SubmissionsTable extends Component {
  editLink = (row) => {
    const { isTeamRoute, isAuditRoute} = this.props;
    let path = 'admin';
    let text = row.attributes && (row.attributes['audit-completed'] && row.attributes.status !== 'DECLINED') ? 'View' : 'View/Edit';
    let action = 'update';

    if (isAuditRoute) {
      path = 'admin/audit';
      text = row.attributes.auditable ? 'Audit' : 'View';
      action = 'audit';
    } else if (isTeamRoute) {
      path = 'team';
    }

    return (
      <Can action={action} subjectClass='Submission'>
        <a
          target="_blank"
          href={`/${path}/submissions/${row.id}`}
          className="red-ghost-btn btn btn-default"
        >
          { text }
        </a>
      </Can>
    );
  }

  render() {
    const {
      submissions, currentPage, onPageChange, paging, isAuditRoute
    } = this.props;
    const dataToDisplay = (submissions || []);

    const actions = [
      (index, row) => (
        <div>
          {this.editLink(row)}
        </div>
      )
    ];

    const columns = [
      {
        prop: 'outlet-code',
        title: 'Outlet code'
      },
      {
        prop: 'type',
        title: 'Type'
      },
      {
        prop: 'created-at',
        title: 'Upload date'
      },
      {
        prop: 'status',
        title: 'Status',
        format(data, row) {
          return (
            <div>
              {row.attributes.type === 'NGP' && row.attributes.status === 'APPROVED' ? 'VALIDATED' : data}
              &nbsp;
              { row.attributes.status === 'DECLINED' && row.attributes['decline-reason'] && (
                <OverlayTrigger
                  overlay={(
                    <Tooltip className="tooltip grey" id="tooltip">
                      {row.attributes['decline-reason']}
                    </Tooltip>
                  )}
                  placement="right"
                >
                  <i className="fa fa-info-circle" aria-hidden="true"/>
                </OverlayTrigger>
              )}
            </div>
          );
        }
      },
      {
        prop: 'rdr-code',
        title: 'RDR'
      },
      {
        prop: 'abm-code',
        title: 'ABM'
      }
    ];

    if (!isAuditRoute) {
      columns.push({
        prop: 'further-validation-required',
        title: 'Validation required',
        width: 160,
        format: data => (data ? 'Y' : 'N')
      }, {
        prop: 'audit-completed',
        title: 'Audit completed',
        format: data => (data ? 'Y' : 'N')
      });
    } else {
      columns.push({
        prop: 'savi-auditor-id',
        title: 'Savi auditor ID'
      });
    }

    return (
      <div>
        <div className="mg-bottom-30">
        </div>
        <Datatable
          data={dataToDisplay}
          columns={columns}
          actions={actions}
          hideId={false}
          remote
          dataSize={paging ? paging.number * paging.size : dataToDisplay.length}
          pagination={{
            page: currentPage,
            sizePerPage: 20,
            onPageChange,
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuditRoute: ownProps.location.pathname.includes('audit'),
  isTeamRoute: ownProps.location.pathname.includes('team')
});

export default withRouter(connect(mapStateToProps)(SubmissionsTable));
